import http from "@/services/http";

export const painel = () => {
  async function getBase() {
    try {
      const { data } = await http.get('/stats/base');
      return data;
    } catch (error) {
      return null;
    }
  }

  async function getRentals() {
    try {
      const { data } = await http.get('/stats/rentals');
      return data;
    } catch (error) {
      return null;
    }
  }

  async function getLastActions() {
    try {
      const { data } = await http.get('/stats/actions');
      return data;
    } catch (error) {
      return null;
    }
  }

  async function getReports(dateStart, dateEnd) {
    try {
      const { data } = await http.get('/stats/reports', {
        params: { date_start: dateStart, date_end: dateEnd }
      });
      return data;
    } catch (error) {
      return null;
    }
  }

  return {getBase,getLastActions,getRentals,getReports};
}